export function activeCompanyTeamStatus(company, category, at = Date.now()) {
    return (company?.teamStatuses || [])
        .filter(item => item.category === category && item.kind === 'not-now-existing-support' && Date.parse(item.activeUntil) > at)
        .sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt))[0];
}
export function latestCompanyTeamStatus(company, category) {
    return (company?.teamStatuses || [])
        .filter(item => item.category === category && item.kind === 'not-now-existing-support')
        .sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt))[0];
}
export function companyTeamStatusLabel(status, at = Date.now()) {
    return Date.parse(status.activeUntil) > at ? 'Not now · Existing support' : 'Previous context · Existing support';
}
export function requiresCustomTeamReengagement(company, category, at = Date.now()) {
    const latest = latestCompanyTeamStatus(company, category);
    if (!latest)
        return undefined;
    const expired = Date.parse(latest.activeUntil) <= at;
    const reengaged = Date.parse(latest.reengagedAt || '');
    // The first outreach after an expired Not now must be bespoke. Once that
    // bespoke re-engagement actually sends, the historical note remains but
    // normal automation may resume for the team.
    return expired && (!Number.isFinite(reengaged) || reengaged < Date.parse(latest.activeUntil)) ? latest : undefined;
}
